import { BaseSendMessageModel } from "./MessageModel";

export interface JobPost {
	Id: number;
	BusinessCategory: string;
	BusinessCategoryId: number;
	Title: string;
	Description: string;
	Link: string;
	DateCreatedUtc: string;
	CreatedByUserId: string;
}


export class CreateJobPostModel extends BaseSendMessageModel {
	businessCategoryId: number;
	title:string;
	description: string;
	link: string;
}

export class EditJobPostModel extends CreateJobPostModel {
	id: number;
	constructor(item?: JobPost) {
		super();
		this.id = item && item.Id;
		this.businessCategoryId = item && item.BusinessCategoryId;
		this.title = item && item.Title;
		this.description = item && item.Description;
		this.link = item && item.Link;
	}
}




// WEBPACK FOOTER //
// ./src/app/models/inModels/JobPost.ts